'use-strict'

import { App } from "../utilities/App";

import { onClickQuantityCounterMinus, onClickQuantityCounterPlus } from "./quantity-counter";

import { breakpoints } from "../utilities/utilities";

function navbarActions() {
	/* Menu */
	$(window).on('resize', () => {

		if ( $('[js-menu]').is('[js-opened]') ) {

			if ( $(window).width() < breakpoints.lg ) App.disableScroll();
			else App.enableScroll();
			
		}
		
	});
	
	$('[js-menu]').on('click', (event) => { if ( $(window).width() < breakpoints.lg ) event.stopPropagation(); });
	$('[js-menu] .menu__wrapper').on('click', (event) => { event.stopPropagation(); });

	$('[js-menu-button]').on('click', (event) => {
		event.stopPropagation();
		onClickMenuButton();
	});

	$('[js-hamburger-close]').on('click', (event) => {
		event.stopPropagation();
		hideMenu()
	});
	$('[js-hamburger-open]').on('click', (event) => {
		event.stopPropagation();
		hideAll('menu');
		showMenu()
	});

	/* Languages */
	$('[js-languages]').on('click', (event) => { event.stopPropagation(); });

	$('[js-languages-button]').on('click', (event) => {
		event.stopPropagation();
		onClickLanguagesButton();
	});

	/* Flags */
	$('[js-flags]').on('click', (event) => { event.stopPropagation(); });

	$('[js-flags-button]').on('click', (event) => {
		event.stopPropagation();
		onClickFlagsButton();
	});

	/* Cart */
	$('[js-navbar-cart]').on('click', (event) => {
		if      ( $(event.target).hasClass('qnt-counter__button--minus') ) onClickCartCounterMinus($(event.target));
		else if ( $(event.target).hasClass('qnt-counter__button--plus') )  onClickCartCounterPlus($(event.target));
		else if ( $(event.target).hasClass('nav-cart__remove') )           onClickCartRemove($(event.target));
		
		event.stopPropagation();
	});

	$('[js-navbar-cart-button]').on('click', (event) => {
		event.stopPropagation();
		onClickNavbarCartButton();
	});

	$('.products-grid__element .products-grid__button button').on('click', (event) => {
		onCLickAddToCartButton();
	});

	$('.add-to-cart__button').on('click', (event) => {
		onCLickAddToCartButton();
	});

	/* Body */
	$('body').on('click', () => { hideAll(); });
	
}

function rollUpNavbar() {
	
	if ( $(window).scrollTop() > 0 ) $('[js-navbar]').addClass('nav--scrolled');
	else $('[js-navbar]').removeClass('nav--scrolled');
	
}

function showMenu() {

	if ( $(window).width() < breakpoints.lg ) {

		$('[js-menu]').attr('js-opened', '').fadeIn(300);
		if ( !$('[js-menu]').is('[js-opened]') ) App.disableScroll();
		
	} else {
		
		$('[js-menu]').attr('js-opened', '').slideDown(300);
		
	}
	$('html').addClass('menu-open');
	$('[js-hamburger-open]').fadeOut(200);
	setTimeout(() => { $('[js-hamburger-close]').fadeIn(200) }, 200);
	
}
function hideMenu() {

	if ( $(window).width() < breakpoints.lg ) {

		if ( $('[js-menu]').is('[js-opened]') ) App.enableScroll(300);
		$('[js-menu]').removeAttr('js-opened').fadeOut(300);
		
	} else {
		
		$('[js-menu]').removeAttr('js-opened').slideUp(300);
		
	}
	$('html').removeClass('menu-open');
	$('[js-hamburger-close]').fadeOut(200);
	setTimeout(() => { $('[js-hamburger-open]').fadeIn(200) }, 200);
	
}
function showNavbarCart() {
	if(! $('[js-navbar-cart]').is(':visible')) {
		$('[js-navbar-cart]').fadeIn(300);
	}	
}
function hideAll(element) {

	if ( element !== 'menu' )      hideMenu();
	if ( element !== 'languages' ) $('[js-languages]').fadeOut(300);
	if ( element !== 'flags' )     $('[js-flags]').slideUp(300);
	if ( element !== 'cart')      $('[js-navbar-cart]').fadeOut(300);
	
}

function onClickMenuButton() {

	hideAll('menu');

	const isOpened = typeof $('[js-menu]').attr('js-opened') !== 'undefined' && $('[js-menu]').attr('js-opened') !== false;
	
	if ( isOpened ) hideMenu();
	else showMenu();
	
}
function onClickLanguagesButton() {

	hideAll('languages');
	$('[js-languages]').toggle(300);
	
}
function onClickFlagsButton() {

	hideAll('flags');
	$('[js-flags]').slideToggle(300);
	
}
function onClickNavbarCartButton() {
	
	hideAll('cart');
	$('[js-navbar-cart]').toggle(300);
	
}

function onCLickAddToCartButton() {
	hideAll('cart');
}

function onClickCartCounterMinus( target ) {
	
	const id = target.data('id');
	const quantity = 1;
	
	onClickQuantityCounterMinus(target);

	App.productMinus( id, quantity );
	
}
function onClickCartCounterPlus( target ) {

	const id = target.data('id');
	const quantity = 1;
	
	onClickQuantityCounterPlus(target);

	App.productPlus( id, quantity );
	
}
function onClickCartRemove( target ) {

	App.productRemove( target.data('id') );
	
}

export {
	navbarActions,
	rollUpNavbar,
	showNavbarCart,
}